import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { verifyPackageById } from "../../ApiController/ApiService";

const Failed = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;

    // 🔴 FAILED status send
    verifyPackageById(id, "Failed").catch((err) => {
      console.error("Verification failed:", err);
    });
  }, [id]);

  const handleRetry = () => {
    navigate("/price-plan");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50">
      <div className="bg-white border border-red-300 p-8 rounded-lg shadow-md max-w-md w-full text-center">
        <h2 className="text-[30px] font-bold text-red-600 mb-4">
          Payment Failed
        </h2>

        <p className="text-gray-700 mb-6">
          Oops! Something went wrong while processing your payment.
          Please try again.
        </p>

        <button
          onClick={handleRetry}
          className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
        >
          Back to Pricing
        </button>
      </div>
    </div>
  );
};

export default Failed;
